export default __webpack_public_path__ + "static/media/line-img.010b51f1.png";